import { render } from "./HacktheChallengeAccess.vue?vue&type=template&id=8b00c5a8"
import script from "./HacktheChallengeAccess.vue?vue&type=script&lang=js"
export * from "./HacktheChallengeAccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__